import Icon from "@/components/Icon";
import Reveal from "@/components/Reveal";
import { capabilities, images } from "@/mock/mock";

export default function Capabilities() {
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">Core Capabilities</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-white">
            Deep expertise across forensics and defense
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {capabilities.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 100}>
              <article className="group h-full overflow-hidden rounded-2xl border border-white/10 bg-brand-navy2/60 card-hover">
                <div className="relative h-48 overflow-hidden">
                  <img src={images[c.image]} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-navy2 via-brand-navy2/40 to-transparent" />
                  <div className="absolute bottom-4 left-4 grid h-11 w-11 place-items-center rounded-xl bg-brand-lime text-brand-navy">
                    <Icon name={c.icon} className="h-5 w-5" />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="font-display text-xl font-semibold text-white">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
